import { render, staticRenderFns } from "./Bread_Crumb.vue?vue&type=template&id=10af1183&scoped=true&"
import script from "./Bread_Crumb.vue?vue&type=script&lang=js&"
export * from "./Bread_Crumb.vue?vue&type=script&lang=js&"
import style0 from "./Bread_Crumb.vue?vue&type=style&index=0&id=10af1183&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af1183",
  null
  
)

export default component.exports